import React from 'react';
import { CheckCircle2, Circle, Clock, AlertCircle, FileText, Printer, Package } from 'lucide-react';

const CuttingPlanTimeline = ({ plan }) => {
  const timelineSteps = [
    {
      id: 'draft',
      label: 'Rascunho',
      icon: FileText,
      date: plan.created_at,
      completed: true
    },
    {
      id: 'planned',
      label: 'Planejado',
      icon: Package,
      date: plan.planned_at,
      completed: ['PLANNED', 'IN_PROGRESS', 'COMPLETED'].includes(plan.status)
    },
    {
      id: 'in_progress',
      label: 'Em Andamento',
      icon: Clock,
      date: plan.started_at,
      completed: ['IN_PROGRESS', 'COMPLETED'].includes(plan.status)
    },
    {
      id: 'completed',
      label: 'Concluído',
      icon: CheckCircle2,
      date: plan.completed_at,
      completed: plan.status === 'COMPLETED'
    }
  ];

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-6">Andamento</h2>

      <div className="relative">
        <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-200" />

        <div className="space-y-6">
          {timelineSteps.map((step, index) => {
            const Icon = step.icon;
            const isLast = index === timelineSteps.length - 1;

            return (
              <div key={step.id} className="relative flex items-start gap-4">
                <div className={`relative z-10 flex items-center justify-center w-8 h-8 rounded-full ${
                  step.completed
                    ? 'bg-emerald-500 text-white'
                    : 'bg-gray-200 text-gray-400'
                }`}>
                  <Icon className="w-4 h-4" />
                </div>

                <div className="flex-1 min-w-0 pt-1">
                  <div className="flex items-center justify-between">
                    <p className={`text-sm font-medium ${
                      step.completed ? 'text-gray-900' : 'text-gray-500'
                    }`}>
                      {step.label}
                    </p>
                    {step.date && (
                      <span className="text-xs text-gray-500">
                        {formatDate(step.date)}
                      </span>
                    )}
                  </div>
                  {!step.date && !step.completed && (
                    <p className="text-xs text-gray-400">Aguardando</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {plan.status === 'CANCELLED' && (
        <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2">
          <AlertCircle className="w-5 h-5 text-red-600" />
          <div>
            <p className="text-sm font-medium text-red-800">Plano Cancelado</p>
            {plan.cancelled_reason && (
              <p className="text-xs text-red-600">{plan.cancelled_reason}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CuttingPlanTimeline;
